<template>
  <Panel
    class="mt-6"
    :class="'share-links'"
    :variant="['30-paddings', 'default', 'rounded']"
  >
    <Subheader
      :text="$$t('Share link', 'sharing_section-title')"
      class="tournament-settings-wrapper__title mb-5"
    />
    <div
      class="row mt-5 w-100 justify-content-between"
      style="max-width: 500px;"
    >
      <div class="col-auto">
        <div class="row">
          <div class="col-auto text-center">
            <QRCodeComponent
              :options="qrFullOptions"
              hidden
              @qrReady="getQRSource"
            />
            <ToolIcon
              icon-name="qr-code"
              icon-size="36"
              :help-text="
                $t(
                  '_web_qr-code-download-tournament-help',
                  'Download QR-code for tournament invitation link'
                )
              "
              class="mb-3"
              @click.stop="downloadQrCode"
            />
            <TextBlock
              tag="div"
              :text="$t('_web_qr-code-download', 'QR code')"
            />
          </div>
        </div>
        <!-- <HeraFormBtn
          :label="$t('_web_qr-code-download', 'Download')"
          class="mt-4"
          @click.stop="downloadQrCode"
        /> -->
      </div>
      <div class="col-auto">
        <div class="row">
          <div class="col-auto text-center">
            <ToolIcon
              v-if="currentTournament.info && currentTournament.info.vanity_id"
              icon-name="copy"
              icon-size="36"
              :help-text="
                $t(
                  '_web_copy-tournament-link-tournament-help',
                  'Copy tournament invitation link to clipboard'
                )
              "
              class="mb-3"
              @click.stop="getInviteLink"
            />
            <TextBlock
              tag="div"
              :text="
                $t('_web_copy-tournament-link-tournament-text', 'Copy link')
              "
            />
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="row">
          <div class="col-auto text-center">
            <ToolIcon
              icon-name="social/fb"
              icon-size="36"
              :help-text="
                $t(
                  '_web_share-fb-tournament-help',
                  'Share tournament link to Facebook'
                )
              "
              class="mb-3"
              @click.stop="shareLinkToFacebook"
            />
            <TextBlock tag="div" text="Facebook" />
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="row">
          <div class="col-auto text-center">
            <ToolIcon
              icon-name="social/twitter"
              icon-size="36"
              :help-text="
                $t(
                  '_web_share-twitter-tournament-help',
                  'Share tournament link to Twitter'
                )
              "
              class="mb-3"
              @click.stop="shareLinkToTwitter"
            />
            <TextBlock tag="div" text="Twitter" />
          </div>
        </div>
      </div>
    </div>
    <!-- <TextBlock variant="secondary" tag="div" class="mt-5">
      {{
        $$t(
          `Share with players for direct invitation`,
          'sharing_section-description'
        )
      }}
    </TextBlock> -->
  </Panel>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import shareQrCodeMixin from '@/mixins/shareQrCode';
import shareFacebookMixin from '@/mixins/shareToFacebook';
import shareTwitterMixin from '@/mixins/shareToTwitter';
import { translate } from '@/mixins/translate';
import { shareLink } from '@/mixins/sharingLink';
import { TOURNAMENT } from '@/constants/accounts';
import Panel from '@/components/atoms/Panel';
import Subheader from '@/components/atoms/Subheader';
import TextBlock from '@/components/atoms/TextBlock';
import QRCodeComponent from '@/components/common/QRCode';
import ToolIcon from '@/views/tournaments/management/brackets/components/ToolIcon';
// import HeraFormBtn from '@/components/atoms/HeraFormBtn';
export default {
  name: 'SharingSection',
  components: {
    Panel,
    Subheader,
    QRCodeComponent,
    ToolIcon,
    TextBlock,
    // HeraFormBtn,
  },
  mixins: [
    shareLink,
    ...shareQrCodeMixin,
    ...shareFacebookMixin,
    ...shareTwitterMixin,
    translate('_web_tournament_settings'),
  ],
  computed: {
    ...mapGetters(['currentTournament']),
    tournamentID() {
      return (
        this.$route.params.tournamentID ||
        this.currentTournament.id ||
        this.currentTournament.tempId
      );
    },
  },
  watch: {
    'currentTournament.info': function() {
      this.setQrPayload();
    },
    'currentTournament.id': function() {
      this.setQrPayload();
    },
    'currentTournament.tempId': function() {
      this.setQrPayload();
    },
  },
  created() {
    if (!this.tournamentID) {
      this.generateTempTournamentId();
      this.generateTempTournamentInvitationToken();
    }
    if (this.currentTournament && this.currentTournament.info) {
      this.$nextTick(() => {
        this.setQrPayload();
      });
    }
  },
  methods: {
    ...mapActions([
      'generateTempTournamentId',
      'generateTempTournamentInvitationToken',
    ]),
    setQrPayload() {
      this.qrPayload = this.generateInviteLink();
    },
    generateInviteLink() {
      return this.getSharingLink({
        type: TOURNAMENT,
        id: this.tournamentID,
        vanityId: this.currentTournament.vanity_id,
        token: this.currentTournament.info.registration_token,
      });
    },
    getInviteLink() {
      this.copyLinkToClipboard(this.generateInviteLink());
    },
    shareLinkToFacebook() {
      this.shareToFacebook({
        text: this.currentTournament.info.title,
        url: this.generateInviteLink(),
      });
    },
    shareLinkToTwitter() {
      this.shareToTwitter({
        text: this.currentTournament.info.title,
        url: this.generateInviteLink(),
      });
    },
  },
};
</script>

<style lang="scss">
.share-links {
  padding-top: 17px !important;
  padding-bottom: 17px !important;
}
</style>
